import { useTranslation } from 'react-i18next';

import Book2Fill from '@/assets/icons/book_2_fill.svg?component';
import QuestionFill from '@/assets/icons/question_fill.svg?component';
import VideoFill from '@/assets/icons/video_fill.svg?component';
import { Card } from '@/components/atoms/Card';
import PageLayout from '@/components/Layout/PageLayout';

import HelpPageDetail from './HelpPageDetail';
import HelpPageFAQ from './HelpPageFAQ';
import HelpPageUserManual from './HelpPageUserManual';
import HelpPageVideos from './HelpPageVideos';

import './Help.scss';
import styles from './HelpPage.module.scss';

function HelpPageContainer() {
    const { t } = useTranslation();

    const USER_MANUAL_LIST = [
        {
            title: t('help.page.userManualInEnglish'),
            link: 'https://storage.googleapis.com/optoscale-public/Bioscope-User-Manual-English.pdf',
        },
        {
            title: t('help.page.userManualInNorwegian'),
            link: 'https://storage.googleapis.com/optoscale-public/Bioskop-brukermanual-Norsk.pdf',
        },
        {
            title: t('help.page.userManualInSpanish'),
            link: 'https://storage.googleapis.com/optoscale-public/1001-MAN-I-003%20Bioscope%20P1%20userrmanual%20Spanish%20rev.4%20Rev%20PIbarra%20110922%20EDITED%20(FINAL).pdf',
        },
        {
            title: t('help.page.userManualForBioscope3'),
            link: 'https://storage.googleapis.com/optoscale-public/Bioskop-3.0-brukermanual-Norsk.pdf',
        },
    ];

    const USER_MANUAL_LIST_WINCH = [
        {
            title: t('help.page.userManualForWinchIn'),
            link: 'https://docs.optoscale.no/winch',
        },
    ];

    const VIDEO_LIST_BIOSCOPE1 = [
        {
            title: t('help.page.videoInEnglish'),
            link: 'https://storage.googleapis.com/optoscale-public/Installation-videos/Engelsk-bioskop-1-1280-Com.mp4',
        },
        {
            title: t('help.page.videoInNorwegian'),
            link: 'https://storage.googleapis.com/optoscale-public/Installation-videos/Norsk-bioskop-1-1280-Com.mp4',
        },
        {
            title: t('help.page.videoInSpanish'),
            link: 'https://storage.googleapis.com/optoscale-public/Installation-videos/Spansk-bioskop-1-1280-Com.mp4',
        },
    ];

    const VIDEO_LIST_BIOSCOPE2 = [
        {
            title: t('help.page.videoInEnglish'),
            link: 'https://storage.googleapis.com/optoscale-public/Installation-videos/Engelsk-bioskop-2-1280-Com.mp4',
        },
        {
            title: t('help.page.videoInNorwegian'),
            link: 'https://storage.googleapis.com/optoscale-public/Installation-videos/Norsk-bioskop-2-1280-Com.mp4',
        },
        {
            title: t('help.page.videoInSpanish'),
            link: 'https://storage.googleapis.com/optoscale-public/Installation-videos/Spansk-bioskop-2-1280-Com.mp4',
        },
    ];

    const VIDEO_LIST_WINCH = [
        {
            title: t('help.page.videoWinch'),
            link: 'https://storage.googleapis.com/optoscale-public/Installation-videos/Engelsk-vinsj.mp4',
        },
    ];

    return (
        <PageLayout title={t('help.page.help')}>
            <div data-type="helpPageContainer" className={styles.layout}>
                <div className={styles.main}>
                    <div className={styles.pair}>
                        <div className={styles.pairItem}>
                            <Card as="section" padding="xl" className={styles.card}>
                                <HelpPageUserManual
                                    headerText={t('help.page.userManual')}
                                    headerIcon={Book2Fill}
                                    description={t('help.page.clickOnTheLinkBelowToSeeOr')}
                                    linkList={USER_MANUAL_LIST}
                                    linkListWinch={USER_MANUAL_LIST_WINCH}
                                />
                            </Card>
                        </div>
                        <div className={styles.pairItem}>
                            <Card as="section" padding="xl" className={styles.card}>
                                <HelpPageFAQ
                                    headerText={t('helpPageFAQ.title')}
                                    headerIcon={QuestionFill}
                                    description={t('helpPageFAQ.description')}
                                />
                            </Card>
                        </div>
                    </div>
                    <Card as="section" padding="xl" className={styles.card}>
                        <HelpPageVideos
                            headerText={t('help.page.installationVideos')}
                            headerIcon={VideoFill}
                            description={t('help.page.clickOnTheLinkBelowToSeeThe')}
                            linkListBioscope1={VIDEO_LIST_BIOSCOPE1}
                            linkListBioscope2={VIDEO_LIST_BIOSCOPE2}
                            linkListWinch={VIDEO_LIST_WINCH}
                        />
                    </Card>
                </div>
                <div className={styles.side}>
                    <Card as="section" padding="xl" className={styles.card}>
                        <HelpPageDetail />
                    </Card>
                </div>
            </div>
        </PageLayout>
    );
}

export default HelpPageContainer;
